import { render, staticRenderFns } from "./acountNav.vue?vue&type=template&id=24607324&scoped=true"
import script from "./acountNav.vue?vue&type=script&lang=js"
export * from "./acountNav.vue?vue&type=script&lang=js"
import style0 from "./acountNav.vue?vue&type=style&index=0&id=24607324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24607324",
  null
  
)

export default component.exports